import React, { PropTypes } from 'react';
import CollaboratorModal from 'project/containers/collaborator_modal';

const InviteButton = ({ toggle, projectId }) => (
  <div>
    <button type="button" className="btn btn-primary btn-md btn-invite-collaborator" onClick={toggle}>
      Invite
    </button>
    <CollaboratorModal projectId={projectId} />
  </div>
);

InviteButton.propTypes = {
  toggle: PropTypes.func.isRequired,
  projectId: PropTypes.number.isRequired,
};

export default InviteButton;



// WEBPACK FOOTER //
// ./project/components/invite_collaborator_button.jsx